import TypographyContainer from "../../../Components/UiKits/Typography/TypographyContainer";

const Typography = () => {
  return <TypographyContainer />;
};

export default Typography;
